module.exports = __webpack_public_path__ + "media/images/bugs-bunny-c8ee713a3bfd527e1ca8136c44c48df3.png";